import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { LoadingPage } from '@pages/other/LoadingPage';
import { PublicErrorBoundary } from '@/shared/components/PublicErrorBoundary';
import { PublicVistoryApprovalPage } from '@/pages/public/vistory/PublicVistoryApprovalPage';

/**
 * Standalone shell for the public vistory approval flow.
 *
 * Provides the minimal provider set (Helmet, error boundary, Suspense) needed
 * to render {@link PublicVistoryApprovalPage} outside the authenticated app.
 */
export function VistoryPublicShell() {
  return (
    <HelmetProvider>
      <PublicErrorBoundary>
        <Suspense fallback={<LoadingPage />}>
          <PublicVistoryApprovalPage />
        </Suspense>
      </PublicErrorBoundary>
    </HelmetProvider>
  );
}
